import React, { useEffect, useState } from 'react';
import { getCookie } from '../../Util';
import { api, credentials } from '../../api';

const BiReporting = () => {
	const [ iframeUrl, setIframeUrl ] = useState( '' );

	useEffect( () => {
		( async () => {
			const AccessToken = getCookie( 'token' );

			try {
				const { data } = await api( {
					url: 'user/authenticate/adhoc',
					headers: {
						AccessToken
					}
				} );
	
				setIframeUrl( `${ credentials.bi.uri }${ data.token }` );
	
			} catch ( err ) {
				console.error( err );
			}
		} )();
	} , [] );

	return (
		<React.Fragment>
			{ iframeUrl
					? <div>
						<iframe src={ iframeUrl } title="bi-reporting" style={ { height: '943px', width: '100%', border: 'none' } }></iframe>
					</div>
					:	<div style={ { height: '943px', width: '100%' } }>
						loading...
					</div>
			}
		</React.Fragment>
	);
};

export default BiReporting;